import { render, staticRenderFns } from "./odetail.vue?vue&type=template&id=c12a0c0c&scoped=true"
import script from "./odetail.vue?vue&type=script&lang=js"
export * from "./odetail.vue?vue&type=script&lang=js"
import style0 from "./odetail.vue?vue&type=style&index=0&id=c12a0c0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12a0c0c",
  null
  
)

export default component.exports